"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
/* tslint:disable:no-shadowed-variable */
const Cookie = class Cookie {
    static setCookie(key, object) {
        js_cookie_1.default.set(key, object.objectUuid);
    }
    static getCookie(key) {
        return js_cookie_1.default.get(key);
    }
    static removeCookie(key) {
        return js_cookie_1.default.remove(key);
    }
};
exports.default = Cookie;
//# sourceMappingURL=Cookie.js.map